import { gql } from "@apollo/client"

const NUMBER_JOB_STEP_FIELDS = gql`
  fragment NumberJobStepFields on NumberJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    responseSensors
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    format {
      unit
      decimals
    }
    canEnterManually
    canUseDevice
    canUseSensor
    logic {
      range
      lowerValue
      upperValue
      outcomes {
        type
        steps
      }
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { NUMBER_JOB_STEP_FIELDS }
